import { AppointmentService } from '$api-client/types.gen'
import { Text } from '$components'

export type ServicesHeadingProps = {
  services: AppointmentService[],
}

export function ServicesHeading({ services }: ServicesHeadingProps) {
  return (
    <div className="flex items-center gap-stack-tight">
      {/* Colour Square */}
      <div
        style={{ backgroundColor: services[0].service.colour }}
        className="size-3.5 min-w-3.5 min-h-3.5 rounded-[5px]"
      />

      {/* Name */}
      <Text
        as="h3"
        type="s"
        className="truncate"
      >
        { services[0].service_values.name }
      </Text>

      {/* Additional Services Badge */}
      { services.length > 1 && (
        <div className="bg-surface text-caption py-stack-dense px-stack-tight rounded-control-sm font-light text-nowrap">
          {`+ ${services.length - 1} more`}
        </div>
      )}
    </div>
  )
}
